@if (!hidden()) {
  @if (open()) {
    <div class="cx-pop">
      @if (view() === 'list') {
        <div class="cx-pop-head">
          <app-icon name="ChatDots" [size]="18" color="var(--accent)"></app-icon>
          <h3>{{ 'messages.chatLauncher.messages' | translate }}</h3>
          <button class="btn sm" (click)="openNew()"><app-icon name="Plus" [size]="12"></app-icon></button>
          <button class="icon-btn" (click)="open.set(false)"><app-icon name="Close" [size]="15"></app-icon></button>
        </div>
        <app-cx-conv-list [convos]="store.convos()" [activeId]="store.activeId()" (select)="openConv($event)" query="" tab="active" [compact]="true"></app-cx-conv-list>
        <button class="btn full-w" style="border-radius:0;border-left:0;border-right:0;border-bottom:0;padding:12px" (click)="goFullInbox()">{{ 'messages.chatLauncher.openFullInbox' | translate }} <app-icon name="ArrowRight" [size]="12"></app-icon></button>
      } @else {
        <div class="cx-pop-head">
          <button class="icon-btn" (click)="view.set('list')"><app-icon name="ArrowLeft" [size]="16"></app-icon></button>
          <h3 style="font-size:13.5px">{{ store.activeConvo() ? title(store.activeConvo()!) : '' }}</h3>
          <button class="icon-btn" (click)="open.set(false)"><app-icon name="Close" [size]="15"></app-icon></button>
        </div>
        @if (store.activeConvo(); as a) {
          <app-cx-thread [conv]="a" [flat]="flat()" [tone]="tone()" [compact]="true" (openInfo)="goFullInbox()"></app-cx-thread>
        }
      }
    </div>
  }
  <div class="cx-launch">
    <button class="cx-launch-btn" (click)="open.set(!open())" [title]="'messages.chatLauncher.messages' | translate">
      @if (open()) { <app-icon name="Close" [size]="22"></app-icon> } @else { <app-icon name="ChatDots" [size]="24"></app-icon> }
      @if (!open() && store.totalUnread()) { <span class="cx-launch-badge">{{ store.totalUnread() }}</span> }
    </button>
  </div>
}
